import * as SwitchPrimitive from '@radix-ui/react-switch';
import * as React from 'react';

import classnames from '../utils/classnames.tsx';

interface SwitchProps
    extends Omit<React.ComponentPropsWithRef<typeof SwitchPrimitive.Root>, 'checked' | 'onCheckedChange' | 'value'> {
    value?: boolean;
    onValueChange?: (value: boolean) => void;
    // sm where rows are dense: tables, menus, filter lists
    size?: 'default' | 'sm';
}

const Switch = ({
    value = undefined,
    onValueChange = undefined,
    size = 'default',
    className,
    ...switchProps
}: SwitchProps) => {
    return (
        <SwitchPrimitive.Root
            className={classnames(
                'flex flex-none items-center justify-between cursor-pointer bg-surface-strong rounded-full relative transition-colors border-none hover:bg-surface-strong-hover data-[state=checked]:bg-surface-brand-strong-default data-[state=checked]:hover:bg-surface-brand-strong-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-line-brand-strong',
                'data-[disabled]:pointer-events-none data-[disabled]:bg-surface-medium data-[disabled]:data-[state=checked]:bg-line-strong',
                size === 'sm' ? 'w-8 h-[1.125rem]' : 'w-10 h-[1.375rem]',
                className
            )}
            checked={value}
            onCheckedChange={onValueChange}
            {...switchProps}
        >
            <SwitchPrimitive.Thumb
                className={classnames(
                    'absolute top-0.5 left-0.5 rounded-full bg-surface-weak shadow-sm data-[state=checked]:left-[calc(100%-0.125rem)] data-[state=checked]:transform-[translateX(-100%)] transition-all',
                    size === 'sm' ? 'w-3.5 h-3.5' : 'w-[1.125rem] h-[1.125rem]'
                )}
            />
        </SwitchPrimitive.Root>
    );
};

export default Switch;
